var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeasureGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 212,
    viewBox: "0 0 254 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2674_225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.049 51.4665V1.36386C254.049 0.586531 253.421 -0.049469 252.638 -0.049469H202.614C201.359 -0.049469 200.731 1.46986 201.62 2.36026L213.395 14.1545C213.946 14.7057 213.946 15.5961 213.395 16.1473L30.7764 199.068L79.8336 198.962L237.871 40.6616C238.421 40.1104 239.31 40.1104 239.861 40.6616L251.636 52.4559C252.525 53.3463 254.042 52.7173 254.042 51.4595L254.049 51.4665Z",
    fill: "#5F3A9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46667 198.955H243.106",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.875 191.485L102.044 200.983C102.574 206.629 113.552 210.947 126.563 210.629C139.573 210.311 149.691 205.477 149.154 199.824L148.985 190.327",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.875 191.485L102.044 200.983C102.574 206.629 113.552 210.947 126.563 210.629C139.573 210.311 149.691 205.477 149.154 199.824L148.985 190.327",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.503 201.154C138.526 201.047 149.045 196.376 148.998 190.721C148.952 185.066 138.358 180.569 125.336 180.676C112.313 180.783 101.794 185.454 101.841 191.109C101.887 196.764 112.481 201.261 125.503 201.154Z",
    fill: "white",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.741 180.645L101.91 190.143C102.44 195.789 113.418 200.107 126.428 199.789C139.439 199.471 149.557 194.637 149.02 188.984L148.851 179.486",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.741 180.645L101.91 190.143C102.44 195.789 113.418 200.107 126.428 199.789C139.439 199.471 149.557 194.637 149.02 188.984L148.851 179.486",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.365 190.322C138.388 190.215 148.907 185.544 148.86 179.889C148.814 174.235 138.22 169.737 125.198 169.844C112.175 169.951 101.656 174.622 101.703 180.277C101.749 185.932 112.343 190.429 125.365 190.322Z",
    fill: "white",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6 169.812L101.769 179.31C102.298 184.956 113.277 189.274 126.287 188.956C139.298 188.638 149.415 183.804 148.879 178.151L148.71 168.653",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6 169.812L101.769 179.31C102.298 184.956 113.277 189.274 126.287 188.956C139.298 188.638 149.415 183.804 148.879 178.151L148.71 168.653",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.234 179.477C138.257 179.37 148.776 174.699 148.729 169.044C148.683 163.389 138.089 158.891 125.067 158.998C112.044 159.105 101.525 163.776 101.572 169.431C101.618 175.086 112.212 179.584 125.234 179.477Z",
    fill: "white",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.466 158.972L101.635 168.469C102.164 174.116 113.143 178.433 126.153 178.115C139.164 177.797 149.281 172.964 148.745 167.31L148.576 157.813",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.466 158.972L101.635 168.469C102.164 174.116 113.143 178.433 126.153 178.115C139.164 177.797 149.281 172.964 148.745 167.31L148.576 157.813",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.096 168.645C138.118 168.538 148.637 163.867 148.591 158.212C148.545 152.557 137.951 148.059 124.928 148.166C111.906 148.273 101.387 152.944 101.433 158.599C101.48 164.254 112.074 168.752 125.096 168.645Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.31 148.139L108.479 157.636C109.008 163.282 119.987 167.6 132.997 167.282C146.008 166.964 156.125 162.131 155.589 156.477L155.42 146.98",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.31 148.139L108.479 157.636C109.008 163.282 119.987 167.6 132.997 167.282C146.008 166.964 156.125 162.131 155.589 156.477L155.42 146.98",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.943 157.805C144.965 157.698 155.484 153.027 155.438 147.372C155.391 141.717 144.797 137.22 131.775 137.327C118.753 137.434 108.234 142.105 108.28 147.76C108.326 153.415 118.921 157.912 131.943 157.805Z",
    fill: "white",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4038 137.305L98.5731 146.803C99.1023 152.449 110.081 156.767 123.091 156.449C136.102 156.131 146.219 151.297 145.683 145.644L145.514 136.146",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4038 137.305L98.5731 146.803C99.1023 152.449 110.081 156.767 123.091 156.449C136.102 156.131 146.219 151.297 145.683 145.644L145.514 136.146",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.04 146.976C135.062 146.869 145.581 142.198 145.535 136.543C145.489 130.888 134.895 126.391 121.872 126.498C108.85 126.605 98.331 131.276 98.3773 136.931C98.4236 142.586 109.018 147.083 122.04 146.976Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.064 126.465L101.233 135.963C101.762 141.609 112.741 145.927 125.751 145.609C138.762 145.291 148.879 140.457 148.343 134.804L148.174 125.306",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.064 126.465L101.233 135.963C101.762 141.609 112.741 145.927 125.751 145.609C138.762 145.291 148.879 140.457 148.343 134.804L148.174 125.306",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.689 136.143C137.711 136.036 148.23 131.365 148.184 125.71C148.138 120.055 137.543 115.557 124.521 115.664C111.499 115.771 100.98 120.442 101.026 126.097C101.072 131.752 111.667 136.25 124.689 136.143Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.114 115.632L105.283 125.129C105.812 130.776 116.791 135.093 129.801 134.775C142.811 134.457 152.929 129.624 152.393 123.971L152.224 114.473",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.114 115.632L105.283 125.129C105.812 130.776 116.791 135.093 129.801 134.775C142.811 134.457 152.929 129.624 152.393 123.971L152.224 114.473",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.749 125.298C141.771 125.191 152.29 120.52 152.244 114.865C152.197 109.21 141.603 104.712 128.581 104.819C115.559 104.926 105.039 109.597 105.086 115.252C105.132 120.907 115.726 125.405 128.749 125.298Z",
    fill: "white",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8606 191.485L27.0299 200.983C27.5591 206.629 38.5375 210.947 51.548 210.629C64.5584 210.311 74.6761 205.477 74.1399 199.824L73.9705 190.327",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8606 191.485L27.0299 200.983C27.5591 206.629 38.5375 210.947 51.548 210.629C64.5584 210.311 74.6761 205.477 74.1399 199.824L73.9705 190.327",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4913 201.149C63.5136 201.042 74.0327 196.371 73.9864 190.716C73.94 185.061 63.3459 180.563 50.3236 180.67C37.3014 180.777 26.7823 185.448 26.8286 191.103C26.8749 196.758 37.4691 201.256 50.4913 201.149Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6766 178.158L22.846 187.655C23.3751 193.302 34.3536 197.619 47.364 197.301C60.3745 196.983 70.4921 192.15 69.9559 186.496L69.7866 176.999",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6766 178.158L22.846 187.655C23.3751 193.302 34.3536 197.619 47.364 197.301C60.3745 196.983 70.4921 192.15 69.9559 186.496L69.7866 176.999",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3113 187.82C59.3335 187.713 69.8526 183.042 69.8063 177.387C69.76 171.732 59.1658 167.235 46.1436 167.342C33.1213 167.449 22.6022 172.12 22.6486 177.775C22.6949 183.43 33.289 187.927 46.3113 187.82Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8606 163.438L27.0299 172.935C27.5591 178.582 38.5375 182.899 51.548 182.581C64.5584 182.263 74.6761 177.43 74.1399 171.777L73.9705 162.279",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8606 163.438L27.0299 172.935C27.5591 178.582 38.5375 182.899 51.548 182.581C64.5584 182.263 74.6761 177.43 74.1399 171.777L73.9705 162.279",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4945 173.102C63.5168 172.995 74.0358 168.324 73.9895 162.669C73.9432 157.014 63.349 152.516 50.3268 152.623C37.3045 152.73 26.7855 157.401 26.8318 163.056C26.8781 168.711 37.4723 173.209 50.4945 173.102Z",
    fill: "white",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.042 191.485L183.212 200.983C183.741 206.629 194.719 210.947 207.73 210.629C220.74 210.311 230.858 205.477 230.322 199.824L230.152 190.327",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.042 191.485L183.212 200.983C183.741 206.629 194.719 210.947 207.73 210.629C220.74 210.311 230.858 205.477 230.322 199.824L230.152 190.327",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.675 201.159C219.697 201.052 230.216 196.381 230.17 190.726C230.124 185.071 219.529 180.573 206.507 180.68C193.485 180.787 182.966 185.458 183.012 191.113C183.058 196.768 193.653 201.266 206.675 201.159Z",
    fill: "#07151F",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.092 178.546L187.261 188.044C187.791 193.69 198.769 198.008 211.78 197.69C224.79 197.372 234.908 192.538 234.371 186.885L234.202 177.387",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.092 178.546L187.261 188.044C187.791 193.69 198.769 198.008 211.78 197.69C224.79 197.372 234.908 192.538 234.371 186.885L234.202 177.387",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.724 188.222C223.747 188.115 234.266 183.444 234.22 177.789C234.173 172.134 223.579 167.637 210.557 167.744C197.535 167.851 187.015 172.522 187.062 178.177C187.108 183.832 197.702 188.329 210.724 188.222Z",
    fill: "#07151F",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.774 167.706L182.943 177.204C183.473 182.85 194.451 187.168 207.461 186.85C220.472 186.532 230.59 181.698 230.053 176.045L229.884 166.547",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.774 167.706L182.943 177.204C183.473 182.85 194.451 187.168 207.461 186.85C220.472 186.532 230.59 181.698 230.053 176.045L229.884 166.547",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.41 177.382C219.432 177.275 229.951 172.604 229.905 166.949C229.858 161.294 219.264 156.797 206.242 156.904C193.22 157.011 182.701 161.682 182.747 167.337C182.793 172.992 193.387 177.489 206.41 177.382Z",
    fill: "white",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.64 156.873L182.809 166.371C183.339 172.017 194.317 176.335 207.327 176.017C220.338 175.699 230.456 170.865 229.919 165.212L229.75 155.714",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.64 156.873L182.809 166.371C183.339 172.017 194.317 176.335 207.327 176.017C220.338 175.699 230.456 170.865 229.919 165.212L229.75 155.714",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.271 166.543C219.294 166.436 229.813 161.765 229.766 156.111C229.72 150.456 219.126 145.958 206.104 146.065C193.081 146.172 182.562 150.843 182.609 156.498C182.655 162.153 193.249 166.65 206.271 166.543Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.69 146.033L186.859 155.53C187.389 161.177 198.367 165.494 211.377 165.176C224.388 164.858 234.506 160.025 233.969 154.371L233.8 144.874",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.69 146.033L186.859 155.53C187.389 161.177 198.367 165.494 211.377 165.176C224.388 164.858 234.506 160.025 233.969 154.371L233.8 144.874",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.324 155.713C223.346 155.606 233.866 150.935 233.819 145.28C233.773 139.625 223.179 135.127 210.156 135.234C197.134 135.341 186.615 140.012 186.661 145.667C186.708 151.322 197.302 155.82 210.324 155.713Z",
    fill: "white",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.946 135.199L188.115 144.697C188.644 150.343 199.623 154.661 212.633 154.343C225.644 154.025 235.761 149.191 235.225 143.538L235.056 134.041",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.946 135.199L188.115 144.697C188.644 150.343 199.623 154.661 212.633 154.343C225.644 154.025 235.761 149.191 235.225 143.538L235.056 134.041",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.583 144.87C224.605 144.763 235.124 140.092 235.078 134.437C235.032 128.782 224.438 124.284 211.415 124.391C198.393 124.498 187.874 129.169 187.92 134.824C187.967 140.479 198.561 144.977 211.583 144.87Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.231 124.366L182.4 133.864C182.929 139.51 193.908 143.828 206.918 143.51C219.929 143.192 230.046 138.358 229.51 132.705L229.341 123.207",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.231 124.366L182.4 133.864C182.929 139.51 193.908 143.828 206.918 143.51C219.929 143.192 230.046 138.358 229.51 132.705L229.341 123.207",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.864 134.041C218.886 133.934 229.405 129.263 229.359 123.608C229.313 117.953 218.719 113.456 205.696 113.563C192.674 113.67 182.155 118.341 182.201 123.996C182.248 129.651 192.842 134.148 205.864 134.041Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.722 113.526L173.891 123.024C174.42 128.67 185.399 132.988 198.409 132.67C211.42 132.352 221.537 127.518 221.001 121.865L220.832 112.367",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.722 113.526L173.891 123.024C174.42 128.67 185.399 132.988 198.409 132.67C211.42 132.352 221.537 127.518 221.001 121.865L220.832 112.367",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.358 123.208C210.381 123.101 220.9 118.43 220.853 112.775C220.807 107.12 210.213 102.622 197.191 102.729C184.168 102.836 173.649 107.507 173.696 113.162C173.742 118.817 184.336 123.315 197.358 123.208Z",
    fill: "white",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.857 96.1703L182.026 105.668C182.555 111.314 193.534 115.632 206.544 115.314C219.555 114.996 229.672 110.162 229.136 104.509L228.967 95.0113",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.857 96.1703L182.026 105.668C182.555 111.314 193.534 115.632 206.544 115.314C219.555 114.996 229.672 110.162 229.136 104.509L228.967 95.0113",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.492 105.842C218.514 105.735 229.033 101.064 228.987 95.4092C228.941 89.7543 218.347 85.2567 205.324 85.3637C192.302 85.4707 181.783 90.1417 181.829 95.7967C181.876 101.452 192.47 105.949 205.492 105.842Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.063 81.4433L179.232 90.9409C179.761 96.5872 190.74 100.905 203.75 100.587C216.761 100.269 226.878 95.4353 226.342 89.782L226.173 80.2844",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.063 81.4433L179.232 90.9409C179.761 96.5872 190.74 100.905 203.75 100.587C216.761 100.269 226.878 95.4353 226.342 89.782L226.173 80.2844",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.698 91.1246C215.72 91.0176 226.239 86.3466 226.193 80.6916C226.146 75.0366 215.552 70.5391 202.53 70.6461C189.508 70.7531 178.988 75.4241 179.035 81.0791C179.081 86.7341 189.675 91.2316 202.698 91.1246Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.254 70.914L183.423 80.4116C183.952 86.0579 194.931 90.3756 207.941 90.0576C220.952 89.7396 231.069 84.906 230.533 79.2527L230.364 69.7551",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.254 70.914L183.423 80.4116C183.952 86.0579 194.931 90.3756 207.941 90.0576C220.952 89.7396 231.069 84.906 230.533 79.2527L230.364 69.7551",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.894 80.5895C219.916 80.4825 230.435 75.8115 230.389 70.1565C230.343 64.5015 219.748 60.004 206.726 60.111C193.704 60.218 183.185 64.889 183.231 70.5439C183.277 76.1989 193.872 80.6965 206.894 80.5895Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.063 57.5863L179.232 67.0839C179.761 72.7301 190.74 77.0479 203.75 76.7299C216.761 76.4119 226.878 71.5783 226.342 65.9249L226.173 56.4273",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.063 57.5863L179.232 67.0839C179.761 72.7301 190.74 77.0479 203.75 76.7299C216.761 76.4119 226.878 71.5783 226.342 65.9249L226.173 56.4273",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.7 67.2684C215.722 67.1614 226.241 62.4904 226.195 56.8354C226.148 51.1804 215.554 46.6829 202.532 46.7899C189.51 46.8968 178.991 51.5679 179.037 57.2228C179.083 62.8778 189.677 67.3754 202.7 67.2684Z",
    fill: "#071520",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.254 42.8664L183.423 52.364C183.952 58.0103 194.931 62.328 207.941 62.01C220.952 61.692 231.069 56.8584 230.533 51.2051L230.364 41.7075",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.254 42.8664L183.423 52.364C183.952 58.0103 194.931 62.328 207.941 62.01C220.952 61.692 231.069 56.8584 230.533 51.2051L230.364 41.7075",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.897 52.5357C219.919 52.4288 230.438 47.7577 230.392 42.1028C230.346 36.4478 219.752 31.9502 206.729 32.0572C193.707 32.1642 183.188 36.8352 183.234 42.4902C183.281 48.1452 193.875 52.6427 206.897 52.5357Z",
    fill: "white",
    stroke: "#07151F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2674_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 212,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureGraph);
export default __webpack_public_path__ + "static/media/measure-graph.5885ea5d4944919de226efd907ae9bd0.svg";
export { ForwardRef as ReactComponent };